import { render, staticRenderFns } from "./ChatNotificationCounter.vue?vue&type=template&id=b1a6d15e&scoped=true&"
import script from "./ChatNotificationCounter.vue?vue&type=script&lang=js&"
export * from "./ChatNotificationCounter.vue?vue&type=script&lang=js&"
import style0 from "./ChatNotificationCounter.vue?vue&type=style&index=0&id=b1a6d15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a6d15e",
  null
  
)

export default component.exports